import { useRef, useState, useEffect } from 'preact/compat'
import { useDispatch, useSelector } from 'react-redux'
import { DataDog } from '../datadog'
import { CARDINAL_STATUSES } from '../constants/cardinal'
import { config } from '../config'
import { cardinalCruiseUpdate } from '../redux/slice/cardinalCruiseSlice'
import {
  updatePaymentPending,
  paymentResponseSelector,
} from '../redux/slice/paymentResponseSlice'

export default function useTimeOut(onTimedOut) {
  const dispatch = useDispatch()
  const paymentResponse = useSelector(paymentResponseSelector)
  const timer = useRef(null)

  const [isTimedOut, setTimedOut] = useState(false)

  useEffect(() => {
    if (isTimedOut) {
      DataDog.info(
        `CardinalCruise timeout after ${config.cardinalCruiseResourcesTimeout} sec.`,
      )
      dispatch(
        cardinalCruiseUpdate({
          cardinalStatus: CARDINAL_STATUSES.timeout,
        }),
      )

      dispatch(updatePaymentPending(false))
      onTimedOut()
    }
  }, [isTimedOut])

  useEffect(
    () => () => {
      clearTimeout(timer.current)
    },
    [],
  )

  const onTimeoutStart = () => {
    timer.current = setTimeout(() => {
      setTimedOut(true)
    }, config.cardinalCruiseResourcesTimeout * 1000)
  }

  const onTimeoutEnd = () => {
    setTimedOut(false)
    clearTimeout(timer.current)
  }

  useEffect(() => {
    if (paymentResponse.hasResponse) {
      onTimeoutEnd()
    }
  }, [paymentResponse.hasResponse])

  return onTimeoutStart
}
